import { render, staticRenderFns } from "./cmp-middle-two.vue?vue&type=template&id=9c826b80&scoped=true"
import script from "./cmp-middle-two.vue?vue&type=script&lang=js"
export * from "./cmp-middle-two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c826b80",
  null
  
)

export default component.exports